import { getProposalContent } from 'common/api/core';

import {
    FETCH_PROPOSAL_CONTENT,
    FETCH_PROPOSAL_CONTENT_SUCCESS,
    FETCH_PROPOSAL_CONTENT_FAILURE,
} from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default (contentId, initTemplate) => (dispatch) => {
    dispatch(multiTemplateReviewActions[FETCH_PROPOSAL_CONTENT]());
    getProposalContent(contentId)
        .then((response) => {
            dispatch(
                multiTemplateReviewActions[FETCH_PROPOSAL_CONTENT_SUCCESS](
                    response.data.data,
                ),
            );
            initTemplate(response.data.data);
        })
        .catch((error) =>
            dispatch(
                multiTemplateReviewActions[FETCH_PROPOSAL_CONTENT_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
